import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface PickingDelays1pDeliveryOrdersProps extends BaseTemplateProps {
  actionUrl: string
}

export const PickingDelays1pDeliveryOrders: TemplateDefinition<PickingDelays1pDeliveryOrdersProps> =
  {
    renderParams: () => ({
      messageKey: 'notificationsDomain.templates.pickingDelays1pDeliveryOrders',
    }),
    getLink: (props: PickingDelays1pDeliveryOrdersProps): string => props?.actionUrl || '',
  }
